import { createRoute } from "@tanstack/react-router";
import { hubLayoutRoute } from "../../portal/PortalLayout";

export const optInRoute = createRoute({
  getParentRoute: () => hubLayoutRoute,
  path: "opt-in",
}).lazy(() => import("./OptIn.lazy").then((d) => d.Route));
